export default "__VITE_ASSET__DnHu600f__"